module.exports = __webpack_public_path__ + "static/media/item_2_4_comp.3980babf.png";